module.exports = __webpack_public_path__ + "midi.219e7cf4bb31157b6b98316e501631fa.png";